import styled from 'styled-components'

import { breakpoints } from '@themenu/design-system'

const BackgroundContainer = styled.div`
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`
const LaptopImageContainer = styled(BackgroundContainer)`
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left;
  }
`

const LogoImageContainer = styled.div`
  height: 80px;
  width: 80px;
  margin: 0 auto;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`

export const GradientBackground = styled(() => (
  <BackgroundContainer>
    <picture>
      <source
        srcSet={`
        /images/background_gradient_s.webp 300w,
        /images/background_gradient_m.webp 600w,
        /images/background_gradient_l.webp 1200w,
        /images/background_gradient_xl.webp 2000w`}
        sizes={`${breakpoints.down('md')} 100vw, 50vw`}
        type="image/webp"
      />
      <source
        srcSet={`
        /images/background_gradient_s.jpg 300w,
        /images/background_gradient_m.jpg 600w,
        /images/background_gradient_l.jpg 1200w,
        /images/background_gradient_xl.jpg 2000w`}
        sizes={`${breakpoints.down('md')} 100vw, 50vw`}
        type="image/jpeg"
      />
      <img src={'/images/background_gradient_xl.jpg'} alt="background gradient" />
    </picture>
  </BackgroundContainer>
))``

export const LaptopImage = styled(() => (
  <LaptopImageContainer>
    <picture>
      <source
        srcSet={`
        /images/laptop_background_s.webp 300w,
        /images/laptop_background_m.webp 600w,
        /images/laptop_background_l.webp 1200w,
        /images/laptop_background_xl.webp 2000w`}
        sizes={`${breakpoints.down('md')} 100vw, 50vw`}
        type="image/webp"
      />
      <source
        srcSet={`
        /images/laptop_background_s.jpg 300w,
        /images/laptop_background_m.jpg 600w,
        /images/laptop_background_l.jpg 1200w,
        /images/laptop_background_xl.jpg 2000w`}
        sizes={`${breakpoints.down('md')} 100vw, 50vw`}
        type="image/jpeg"
      />
      <img src={'/images/laptop_background_xl.jpg'} alt="laptop" />
    </picture>
  </LaptopImageContainer>
))``

export const MobileImage = styled(() => (
  <BackgroundContainer>
    <picture>
      <source
        srcSet={`
        /images/mobile_background_s.webp 300w,
        /images/mobile_background_m.webp 600w,
        /images/mobile_background_l.webp 1200w,
        /images/mobile_background_xl.webp 2000w`}
        sizes="100vw"
        type="image/webp"
      />
      <source
        srcSet={`
        /images/mobile_background_s.jpg 300w,
        /images/mobile_background_m.jpg 600w,
        /images/mobile_background_l.jpg 1200w,
        /images/mobile_background_xl.jpg 2000w`}
        sizes="100vw"
        type="image/jpg"
      />
      <img src={'/images/mobile_background_xl.jpg'} alt="laptop" />
    </picture>
  </BackgroundContainer>
))``

export const SwileLogo = styled(() => (
  <LogoImageContainer>
    <picture>
      <source srcSet={'/images/logo_x1.webp 1x, /images/logo_x2.webp 2x'} type="image/webp" />
      <img src="/images/logo_x1.png" srcSet="/images/logo_x1.png, /images/logo_x2.png 2x" alt="swile logo" />
    </picture>
  </LogoImageContainer>
))``
